import axios from "axios";
import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import UserCallList from "./UserCallList";

export default function CallDetails() {


  const [buffer, setBuffer] = useState(false)
  const { state } = useLocation()

  const { event_id, slot, from } = state;
  const [callList, setCallList] = useState([])
  useEffect(() => {
    getAllCallList()
  }, [])

  /**
 * get all register list
 */
  const getAllCallList = () => {
    setBuffer(true)
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/registeredUserList/${event_id}`).then((res) => {
        setBuffer(false)
        if (res.data.status === 200) {
          setCallList(res.data.registeredLiveChats)


        }
      });
    });
  }



  return (
    <div>
      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th>#</th>
            <th>Person Name</th>
            <th>Run Time</th>
            <th>Time left</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>

          {!buffer && callList.map((item, index) => {
            return (
              <UserCallList item={item} index={index} from={from} />
            );
          })}


          {/* skaliton  */}
          {buffer && [1, 2, 3, 4, 5].map((item, index) => {
            return (
              <tr>
                <td>
                  {index + 1}

                </td>
                <td className='w-50'>
                  <div>
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center ">
                        <SkeletonTheme
                          baseColor="#202020"
                          highlightColor="#444"
                          height={50}
                          width={50}
                          borderRadius={100}

                        >

                          <Skeleton count={1} />

                        </SkeletonTheme>
                      </div>
                      <div className="col-md-11 ">
                        <SkeletonTheme
                          baseColor="#202020"
                          highlightColor="#444"
                          height={40}
                        >

                          <Skeleton count={1} />

                        </SkeletonTheme>
                      </div>
                    </div>


                  </div>

                </td>
                <td>
                  {" "}
                  <button className="btn btn-success btn-sm w-25" disabled={true} style={{ height: 50, width: 100, padding: '5px 10px 5px' }}>
                    <i className="fa-solid fa-phone" color="red"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
